var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#067BC2",
    fillRule: "evenodd",
    d: "M5.19 4.17l.003.003a.895.895 0 0 0 1.267.044l.92-.861a.45.45 0 0 1 .757.328v5.59a.9.9 0 1 0 1.8 0V3.699a.45.45 0 0 1 .76-.325l.877.835a.893.893 0 1 0 1.23-1.297L10.242.49a1.8 1.8 0 0 0-2.477.006L5.229 2.915a.894.894 0 0 0-.038 1.254zM18 15.5c0 .88-.612 1.6-1.9 1.6H1.6A1.6 1.6 0 0 1 0 15.5V9.7c0-.838.636-1.6 1.7-1.6h1.006c.494 0 .894.4.894.894v.011c0 .494-.4.895-.894.895h-.012c-.493 0-.894.4-.894.894v3.611c0 .495.4.895.894.895h12.612c.493 0 .894-.4.894-.895v-3.611c0-.494-.4-.894-.894-.894h-.012a.894.894 0 0 1-.894-.895v-.011c0-.494.4-.894.894-.894H16.4A1.6 1.6 0 0 1 18 9.7v5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon_export.0f6727d9f4ac91f8dc249017af913bf1.svg";
export { ForwardRef as ReactComponent };